import React, { FC, useCallback, useMemo } from 'react';
import { TableCell, TableRow } from '@material-ui/core';
import { v4 as uuid } from 'uuid';
import moment from 'moment';
import { CashbackTransactionStatus, SubCashbackCommissionReport } from '../../IBClientsCashbackModel';
import { ColumnsSelect, CustomTable } from '../../../../../components';
import { useCommonStyles } from '../../../../../styles';

interface Props {
  translation: any;
  campaignName: string;
  columnNames: string[];
  selectedColumns: string[];
  rows: SubCashbackCommissionReport[];
  onSelectColumns: (columns: string[]) => void;
}

export const DetailedTable: FC<Props> = ({ translation, columnNames, selectedColumns, rows, campaignName, onSelectColumns }) => {
  const commonClasses = useCommonStyles();

  const renderHeader = useMemo((): any[] => {
    const result: any[] = [];

    columnNames.forEach((columnName) => {
      const isSelected = selectedColumns.includes(columnName);

      if (isSelected) {
        result.push(
          <TableCell key={columnName} align="left">
            {columnName}
          </TableCell>,
        );
      }
    });
    result.push(
      <TableCell key="columns" align="center" className={commonClasses.btnCell}>
        <ColumnsSelect translation={translation} reportColumns={columnNames} selectedColumns={selectedColumns} handleSelectColumns={(columns) => onSelectColumns(columns)} />
      </TableCell>,
    );
    return result;
  }, [selectedColumns, columnNames, commonClasses, translation, onSelectColumns]);

  const renderRows = useCallback((): any[] => {
    const result: any[] = [];

    rows.forEach((row: any) => {
      result.push(
        <TableRow className={commonClasses.tableRow} key={uuid()}>
          {selectedColumns.includes(columnNames[0]) && <TableCell align="left">{row.login ? row.login : '-'}</TableCell>}
          {selectedColumns.includes(columnNames[1]) && <TableCell align="left">{row.calculationDate || row.calculationDate === '' ? `${moment(row.calculationDate).format('DD-MM-YYYY')}` : '-'}</TableCell>}
          {selectedColumns.includes(columnNames[2]) && (
            <TableCell align="left">{(row.periodStart || row.periodStart === '') && (row.periodEnd || row.periodEnd === '') ? `${moment(row.periodStart).format('DD-MM-YYYY')} - ${moment(row.periodEnd).format('DD-MM-YYYY')}` : '-'}</TableCell>
          )}
          {selectedColumns.includes(columnNames[3]) && <TableCell align="left">{campaignName || '-'}</TableCell>}
          {selectedColumns.includes(columnNames[4]) && <TableCell align="left">{row.volumeUsd || row.volumeUsd === 0 ? row.volumeUsd.toFixed(2) : '-'}</TableCell>}
          {selectedColumns.includes(columnNames[5]) && <TableCell align="left">{row.volumeLots || row.volumeLots === 0 ? row.volumeLots.toFixed(2) : '-'}</TableCell>}
          {selectedColumns.includes(columnNames[6]) && <TableCell align="left">{row.commission || row.commission === 0 ? row.commission.toFixed(2) : '-'}</TableCell>}
          {selectedColumns.includes(columnNames[7]) && <TableCell align="left">{row.cashbackAmount || row.cashbackAmount === 0 ? row.cashbackAmount.toFixed(2) : '-'}</TableCell>}
          {selectedColumns.includes(columnNames[8]) && (
            <TableCell align="left">
              {CashbackTransactionStatus[row.transactionStatus] === 'Settled'
                ? translation.settled
                : CashbackTransactionStatus[row.transactionStatus] === 'Rejected'
                ? translation.rejected
                : CashbackTransactionStatus[row.transactionStatus] === 'Failed'
                ? translation.text_5726
                : translation.text_1150}
            </TableCell>
          )}
          <TableCell className={commonClasses.btnCell} align="center" />
        </TableRow>,
      );
    });

    return result;
  }, [columnNames, selectedColumns, rows, campaignName, commonClasses, translation]);

  return <CustomTable headerCells={renderHeader} rows={renderRows()} columnsNumber={selectedColumns.length + 1} emptyDataMessage={translation.text_6496} />;
};
